<template>
    <div>
      <div class="header">
        <div class="head-left">
          <div class="sweb-logo"><i class="mc-logo iconfont icon-xihongshi"></i>美菜供应商</div>
        </div>
        <div class="head-right">
          客服电话：<span>4006-135-135</span>
        </div>
      </div>
      <div class="warning">
        <!--<img src="../../assets/image/warning.png">-->
        <div class="warning-info">
          <p class="info1">{{warnInfo}}</p>
          <!--<p class="info2">如有疑问，请联系美菜客服 400-135-135</p>-->
          <p class="back" @click="back">返回登录页</p>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: 'userError',
  props: ['warnInfo'],
  methods: {
    back () {
      window.location.href = '/sweb/login/loginOut'
    }
  }
}
</script>

<style scoped lang="scss">
.header{
  height: 60px;
  border-bottom: 1px solid #e4e4e4;
  .head-left{
    float: left;
    width: 181px;
    background-color:#05BD72;
    background: linear-gradient(to bottom, #00CF84 0%,#41A8E6 100%);
    .sweb-logo{
      height:60px;
      line-height:60px;
      text-align:center;
      color:#fff;
      font-size:18px;
      .mc-logo{
        margin-right:10px;
        font-size:20px;
      }
    }
  }
  .head-right{
    float: right;
    line-height: 60px;
    font-size: 14px;
    padding: 0 30px;
    span{
      color: #01c675;
    }
  }
}
.warning{
  display: flex;
  padding: 70px;
  img{
    width: 63px;
    height: 63px;
  }
  .warning-info{
    padding-left: 40px;
    color: #999999;
    .info1{
      font-size: 28px;
    }
    .info2{
      font-size: 18px;
      padding-top: 5px;
    }
    .back{
      font-size: 20px;
      color: #01c674;
      margin-top: 20px;
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/error/userError.vue